import type { RecordFormField } from "features/shared/components/dynamic-form/types";
import type { TFunction } from "i18next";

import { FilterTypes } from "enums/components";
import { buildRecordFormField } from "features/shared/lib/technical-config-tab/recordFormFields";

import type { TechnicalDataScenarioFormState } from "../model/types";

type BuildScenarioFormFieldsParams = {
  formState: TechnicalDataScenarioFormState;
  onFieldChange: (field: keyof TechnicalDataScenarioFormState, value: unknown) => void;
  t: TFunction;
};

export const buildScenarioFormFields = ({
  formState,
  onFieldChange,
  t,
}: BuildScenarioFormFieldsParams): RecordFormField[] => [
  buildRecordFormField({
    colSpan: 2,
    config: formState,
    filterType: FilterTypes.INPUT,
    inputType: "string",
    key: "name",
    label: t("TechnicalData.scenario.fields.name"),
    onFieldChange,
  }),
  buildRecordFormField({
    config: formState,
    filterType: FilterTypes.INPUT,
    inputType: "number",
    key: "occupancy",
    label: t("TechnicalData.scenario.fields.occupancy"),
    onFieldChange,
  }),
  buildRecordFormField({
    config: formState,
    filterType: FilterTypes.INPUT,
    inputType: "number",
    key: "internalLoads",
    label: t("TechnicalData.scenario.fields.internalLoads"),
    onFieldChange,
  }),
  buildRecordFormField({
    colSpan: 2,
    config: formState,
    filterType: FilterTypes.INPUT,
    inputType: "number",
    key: "heatRecoveryEff",
    label: t("TechnicalData.scenario.fields.heatRecoveryEfficiency"),
    onFieldChange,
  }),
];
